<template>
  <ui-menuitem :value="value">
    <span class="tw-flex" :class="iconPosition">
      <ui-icon
        v-if="icon"
        :type="type"
        class="c-menuitem-icon"
        :class="iconClass"
        data-test="custom-icon"
      >
        {{ icon }}
      </ui-icon>
      <ui-menuitem-text>
        <slot name="text"></slot>
      </ui-menuitem-text>
    </span>
    <ui-menuitem-icon v-if="hasArrow">
      <ui-icon type="round" data-test="chevron-right-icon">
        chevron_right
      </ui-icon>
    </ui-menuitem-icon>
  </ui-menuitem>
</template>

<script>
export default {
  name: 'DropdownItem',

  props: {
    value: {
      type: String,
      default: null,
    },
    type: {
      type: String || Number,
      default: 'filled',
    },
    icon: {
      type: String,
      default: '',
    },
    iconPosition: {
      type: String,
      default: 'tw-items-center',
    },
    hasArrow: {
      type: Boolean,
      default: true,
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.c-menuitem-icon {
  font-size: 24px;
  margin-right: 18px;
}
</style>
